import * as React from "react";
const SvgFiRrCaravan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-caravan_svg__a)">
      <path
        fill="#062147"
        d="M23.04 18.72h-1.92V6.24A5.766 5.766 0 0 0 15.36.48h-9.6A5.766 5.766 0 0 0 0 6.24v9.6a4.81 4.81 0 0 0 3.943 4.722 3.853 3.853 0 0 0 7.456.077H23.04a.96.96 0 1 0 0-1.92M1.92 8.16h4.32a.48.48 0 0 1 .48.48v.96a.48.48 0 0 1-.48.48H1.92zM7.68 21.6a1.92 1.92 0 1 1 0-3.84 1.92 1.92 0 0 1 0 3.84m7.68-2.88h-2.88V8.64a.48.48 0 0 1 .48-.48h1.92a.48.48 0 0 1 .48.48zm3.84 0h-1.92V8.64a2.4 2.4 0 0 0-2.4-2.4h-1.92a2.4 2.4 0 0 0-2.4 2.4v8.502a3.874 3.874 0 0 0-6.566 1.461 2.88 2.88 0 0 1-2.074-2.764V12h4.32a2.4 2.4 0 0 0 2.4-2.4v-.96a2.4 2.4 0 0 0-2.4-2.4H1.92A3.84 3.84 0 0 1 5.76 2.4h9.6a3.84 3.84 0 0 1 3.84 3.84z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-caravan_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCaravan;
